import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { RotateCcw, ShieldCheck, Truck } from "lucide-react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { HomeHero } from "@/components/home/HomeHero";
import { OutletBanner, SportsGrid } from "@/components/home/SportsGrid";
import { StoreInfo } from "@/components/home/StoreInfo";

const PERKS = [
  { icon: Truck, t: "Envío gratis", d: "En pedidos desde 50 €" },
  { icon: RotateCcw, t: "Devoluciones", d: "15 días para cambiar o devolver" },
  { icon: ShieldCheck, t: "Pago fácil", d: "Bizum o transferencia" },
];

export default function Home() {
  const [featured, setFeatured] = useState([]);
  useEffect(() => {
    api.get("/products", { params: { featured: true } }).then((r) => setFeatured(r.data.slice(0, 8)));
  }, []);

  return (
    <div data-testid="home-page">
      <HomeHero />
      <section className="border-y bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 grid sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x">
          {PERKS.map(({ icon: I, t, d }) => (
            <div key={t} className="flex items-center gap-4 py-6 sm:px-6 first:pl-0">
              <I className="w-6 h-6 text-brand" />
              <div><p className="font-bold text-sm uppercase tracking-wide">{t}</p><p className="text-xs text-slate-500">{d}</p></div>
            </div>
          ))}
        </div>
      </section>
      <SportsGrid />
      <OutletBanner />
      {featured.length > 0 && (
        <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10 mt-24">
          <div className="flex items-end justify-between">
            <div>
              <p className="eyebrow">Destacados</p>
              <h2 className="mt-2 font-heading text-3xl lg:text-5xl font-black uppercase tracking-tight">Lo más vendido</h2>
            </div>
            <Link to="/tienda" className="text-sm font-semibold uppercase tracking-wide hover:text-brand" data-testid="home-view-all">Ver todo →</Link>
          </div>
          <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-10" data-testid="featured-grid">
            {featured.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        </section>
      )}
      <StoreInfo />
    </div>
  );
}
